import BaseComponent from "@js/components/base_component.jsx";

class EuiDiskQueueSummaryIndex extends BaseComponent {

  constructor(props) {
    super(props);

    var needsData = _.isUndefined(props.data) || _.isNull(props.data);

    this.state = {
      loading: needsData,
    }
  }

  componentDidMount() {
    if (this.state.loading) {
      this._urlNavigator(window.location.href, true);
    }

    window.onpopstate = (e) => {
      if (e.state !== null && e.state.url) {
        this._loadFromUrl(e.state.url, () => {});
      }
    };
  }

  render() {

    const groupBySelection = this.state.group_by || "virtualmta_injected";
    const groupByOptions = [ "virtualmta_injected", "virtualmta_most_recent" ];

    const groupVariantSelection = this.state.group_variant || "none";
    const groupVariantOptions = [ "none", "recipient_domain", "all_throttles", "all_throttles_other", "only_explicit_throttles", "not_explicit_throttles" ];

    const sortBySelection = this.state.sort_by || "num_messages_desc";
    const sortByOptions = [ "num_messages_desc", "num_messages_asc", "avg_age_desc", "avg_age_asc", "max_age_desc", "max_age_asc" ];

    const limitSelection = "n" + ( this.state.limit || "100" );
    const limitOptions = [ "n100", "n500", "n2500", "n5000", "n10000" ];

    return this.state.loading ? (
      <center>
        <br />
        <br />
        <br />
        <div className="loader" />
      </center>
    ) : (
      <div data-no-turbolink="true">
        <div className="dynamic-delivery-header" style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}>
          <EuiDynamicDeliveriesGroupFilter
            id={"group-by"}
            group={groupBySelection}
            groups={groupByOptions}
            width={250}
            onChange={x => {
              this._urlNavigator(
                this._urlParams({ group_by: x, page: 1 }, false)
              );
            }}
          />

          <EuiDynamicDeliveriesGroupFilter
            id={"group-variant"}
            group={groupVariantSelection}
            groups={groupVariantOptions}
            width={250}
            onChange={x => {
              this._urlNavigator(
                this._urlParams({ group_variant: x, page: 1 }, false)
              );
            }}
          />

          <EuiDynamicDeliveriesGroupFilter
            id={"sort-by"}
            group={sortBySelection}
            groups={sortByOptions}
            width={250}
            label={I18n.t("labels.sort_by")}
            icon={"arrows-v"}
            onChange={x => {
              this._urlNavigator(
                this._urlParams({ sort_by: x, page: 1 }, false)
              );
            }}
          />

          <EuiDynamicDeliveriesGroupFilter
            id={"limit"}
            group={limitSelection}
            groups={limitOptions}
            width={250}
            label={I18n.t("labels.limit")}
            icon={"hashtag"}
            onChange={x => {
              this._urlNavigator(
                this._urlParams({ limit: x, page: 1 }, false)
              );
            }}
          />

        </div>

        {
          this.state.success
          ? this._renderTable()
          : this._renderError()
        }

        {
          this.state.success &&
          !_.isUndefined(this.state.summary.total_messages_in_queue) &&
          !_.isUndefined(this.state.summary.total_recipients_in_queue) && (
            <div style={{ textAlign: "center" }}>
              <em>
                There are currently { numberWithCommas(this.state.summary.total_messages_in_queue) } { I18n.t("labels.num_messages", { count: this.state.summary.total_messages_in_queue }) }
                {' '}
                (to { numberWithCommas(this.state.summary.total_recipients_in_queue) } { I18n.t("labels.num_recipients", { count: this.state.summary.total_recipients_in_queue }) })
                {' '}
                in the disk queue.
              </em>
            </div>
          )
        }
      </div>
    );
  }

  _renderTable() {
    return (
      <table className="table table-hover">
        <thead>
          <tr>
            <th style={{ width: "200px" }}>{ "VirtualMTA" }</th>
            {
              ( this.state.group_variant === "recipient_domain" ) && (
                <React.Fragment>
                  <th>{ "Recipient Domain" }</th>
                </React.Fragment>
              )
            }
            {
              ( this.state.group_variant.match(/throttle/g) ) && (
                <React.Fragment>
                  <th>{ "Throttle" }</th>
                </React.Fragment>
              )
            }
            <th style={{ width: "115px", textAlign: "right" }}>{ "Num Messages" }</th>
            <th style={{ width: "115px", textAlign: "right" }}>{ "Avg Age" }</th>
            <th style={{ width: "115px", textAlign: "right" }}>{ "Max Age" }</th>
          </tr>
        </thead>
        <tbody>
          {
            this.state.report.map((row, ii) => {
              return (
                <tr key={ ii }>
                  <td>
                    {
                      ( row.mta && row.mta.id ) ? (
                        <React.Fragment>
                          { row.mta.name }
                          &nbsp;{ `(${ row.mta.id })` }
                          {
                            row.mta.ip && (
                              <React.Fragment>
                                <br />
                                { row.mta.ip }
                              </React.Fragment>
                            )
                          }
                        </React.Fragment>
                      ) : ( row.mta && row.mta.name ) ? (
                        <em>{ row.mta.name }</em>
                      ) : (
                        <em>{ "(not specified)" }</em>
                      )
                    }
                  </td>
                  {
                    ( this.state.group_variant === "recipient_domain" ) && (
                      <React.Fragment>
                        <td>{ row.domain.recipient_domain }</td>
                      </React.Fragment>
                    )
                  }
                  {
                    ( this.state.group_variant.match(/throttle/g) ) && (
                      <React.Fragment>
                        <td>
                          {
                            row.throttle && row.throttle.throttle_id ? (
                              <a href={ Routes.eui_virtual_mta_eng_throttle_path(row.throttle.throttle_id) }>
                                { row.throttle.domains.split(/,/g).reduce((p, n) => [ p, <br/>, n ]) }
                              </a>
                            ) : (
                              <span>
                                {
                                  row.throttle.domains === "OTHER"
                                  ? <em>Domains not explicitly throttled</em>
                                  : row.throttle.domains.split(/,/g).reduce((p, n) => [ p, <br/>, n ])
                                }
                              </span>
                            )
                          }
                        </td>
                      </React.Fragment>
                    )
                  }
                  <td style={{ textAlign: "right" }}>{ numberWithCommas(row.stats.num_messages) }</td>
                  <td style={{ textAlign: "right" }}>{ secondsToDuration(row.stats.average_message_age) }</td>
                  <td style={{ textAlign: "right" }}>{ secondsToDuration(row.stats.oldest_message_age) }</td>
                </tr>
              );
            })
          }
          {
            this.state.report.length === 0 && (
              <tr>
                <td colspan="5">
                  <em>{ t("phrases.no_messages_found") }</em>
                </td>
              </tr>
            )
          }
        </tbody>
      </table>
    );
  }

  _urlParams(extras) {
    var state = _.extend({}, this.state, extras);
    var params = {};

    var keys = [
      "sort",
      "direction",
      "per_page",
      "page",
      "group_by",
      "group_variant",
      "sort_by",
      "limit",
    ];

    _.each(keys, key => {
      var value = state[key];

      if (!_.isUndefined(value) && !_.isNull(value) && value !== "") {
        params[key] = value;
      }
    });

    if (_.keys(params).length > 0) {
      return "?" + $.param(params);
    } else {
      return "";
    }
  }

  _renderError() {
    return (
      <div class="alert alert-danger">
        { this.state.error_message }
      </div>
    );
  }

  _urlNavigator(url, isFirstLoad) {
    var savedState = { loading: true, url: url };

    if (isFirstLoad) {
      window.history.replaceState(savedState, "", url);
    } else {
      window.history.pushState(savedState, "", url);
    }

    this._loadFromUrl(url, () => {});
  }

  _loadFromUrl(url, callback) {
    // The requestId will help us to only load what we're actually wanting to
    // look at. This handles the case where a user clicks "back" in quick
    // succession, so we don't see a cascade of loads. We could try to cancel
    // the AJAX requests that are in flight - but that would involve tracking
    // more data. Instead we'll simply ignore the results.
    var requestId = "request-" + _.uniqueId();

    this.setState(
      {
        loading: true,
        activeRequestId: requestId
      },
      () => {
        $.ajax({
          method: "GET",
          url: url,
          dataType: "json",
          success: (response) => {
            if (this.state.activeRequestId === requestId) {
              if (response.system_time) {
                $("#system-time-description").text(response.system_time);
              }

              this.setState(
                _.extend({}, response, { loading: false, url: url }),
                () => {
                  callback(response);
                }
              );
            }
          },
          error: (response) => {
            alert("There was an error while retrieving disk queue summary.");
          }
        });
      }
    );
  }

}

export default EuiDiskQueueSummaryIndex;
